<template>
  <v-card class="card">
    <v-form ref="form" @submit.prevent="save">
      <v-card-title>
        {{
          viewType === "edit" ? "Edit" : viewType === "view" ? "View" : "Add"
        }}
        <span style=" color: rgb(8, 47, 177);"> Location</span>
        <v-btn
          icon="mdi-close"
          variant="text"
          @click="closeDialog"
          class="float-right"
        />
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12" class="px-0 py-0 d-flex align-center justify-center">
            <v-radio-group
              :disabled="showReadOnly"
              v-model="formData.active"
              inline
            >
              <v-radio color="primary" label="Active" :value="1"></v-radio>
              <v-radio color="error" label="Inactive" :value="0"></v-radio>
            </v-radio-group>
          </v-col>
          <v-col cols="6" class="px-1 py-0">
            <v-label class="label">
              Address Type <span v-if="!showReadOnly" class="labelStar">*</span>
            </v-label>
            <AutoComplete
              v-model="formData.addressType"
              :items="addressType"
              placeholder="Select Location Type"
              :rules="getRules('Location Type')"
            />
          </v-col>

          <!-- Apartment -->
          <v-col cols="6" class="px-1 py-0">
            <v-label class="label">
              Apartment <span v-if="!showReadOnly" class="labelStar">*</span>
            </v-label>
            <TextFieldComponent
              placeholder="Apartment/Suite/Building"
              v-model="formData.address1"
              :showReadOnly="showReadOnly"
              :rules="getRules('Apartment')"
            />
          </v-col>

          <!-- Street -->
          <v-col cols="6" class="px-1 py-0">
            <v-label class="label">
              Street <span v-if="!showReadOnly" class="labelStar">*</span>
            </v-label>
            <TextFieldComponent
              placeholder="Street/Avenue"
              v-model="formData.address2"
              :showReadOnly="showReadOnly"
              :rules="getRules('Street')"
            />
          </v-col>

          <!-- Landmark -->
          <v-col cols="6" class="px-1 py-0">
            <v-label class="label">
              Landmark <span v-if="!showReadOnly" class="labelStar">*</span>
            </v-label>
            <TextFieldComponent
              placeholder="Landmark"
              v-model="formData.address3"
              :showReadOnly="showReadOnly"
              :rules="getRules('Landmark')"
            />
          </v-col>
              <v-col cols="9" class="px-1 py-0">
                <v-label class="label">
                  City <span v-if="!showReadOnly" class="labelStar">*</span>
                </v-label>
                <TextFieldComponent
                  placeholder="City"
                  v-model="formData.city"
                  :showReadOnly="showReadOnly"
                  :rules="getRules('City')"
                />
              </v-col>
              <v-col cols="3" class="px-1 py-0">
                <v-label class="label">
                  Zip Code <span v-if="!showReadOnly" class="labelStar">*</span>
                </v-label>
                <TextFieldComponent
                  placeholder="Zip"
                  v-model="formData.zip_code"
                  :rules="getRules('Zip Code')"
                  :showReadOnly="showReadOnly"
                  @change="$emit('update:formData', formData)"
                />
              </v-col>

              <v-col cols="6" class="px-1 py-0">
                <v-label class="label">
                  Country <span v-if="!showReadOnly" class="labelStar">*</span>
                </v-label>
                <AutoComplete
                  v-model="formData.country"
                  item-value="code"
                  item-title="name"
                  :items="countryData"
                  :showReadOnly="showReadOnly"
                  placeholder="Country"
                  :rules="getRules('Country')"
                  @update:model-value="chooseState"
                />
              </v-col>
              <v-col cols="6" class="px-1 py-0">
                <v-label class="label">
                  State <span v-if="!showReadOnly" class="labelStar">*</span>
                </v-label>
                <AutoComplete
                  v-model="formData.state"
                  :items="stateData"
                  item-value="name"
                  item-title="name"
                  :showReadOnly="showReadOnly"
                  placeholder="State"
                  :rules="getRules('State')"
                />
              </v-col>

              <v-col cols="6" class="px-1 py-0">
                <v-label class="label">
                  Website 
                </v-label>
                <TextFieldComponent
                  placeholder="Website"
                  v-model="formData.website"
                  :showReadOnly="showReadOnly"
                />
              </v-col>
        </v-row>
      </v-card-text>

      <!-- Actions -->
      <v-card-actions v-if="!showReadOnly">
        <v-spacer />
        <v-btn
          class="cancel"
          color="grey"
          variant="outlined"
          @click="closeDialog"
        >
          Cancel
        </v-btn>

        <v-btn type="submit" class="save" color="rgb(8, 47, 177)" variant="flat">
          Save
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import AutoComplete from "@/components/ui/AutoComplete.vue";
import TextFieldComponent from "@/components/TextFieldComponent.vue";
import { getGeographicData } from "./index.js";

export default {
  components: {
    TextFieldComponent,
    AutoComplete,
  },
  props: {
    showReadOnly: { type: Boolean, default: false },
    id: { type: Number, default: null },
    viewType: { type: String, default: "Add" },
    index: {},
    editLocationData: { type: Object, default: () => ({}) },
  },
  watch: {
    editLocationData: {
      handler(newVal) {
          this.handleEditLocation(newVal);
        },
        deep: true, 
      immediate: true, 
      },
      
    },
  data() {
    return {
      formData: {
        address1: null,
        address2: null,
        address3: null,
        city: null,
        zip_code: null,
        active:1
      },
      addressType: ["Registered Office" ],
      stateData: [],
      countryData: [],
      codeError: false,
      saveLoader: false,
      snackbar: false,
      snackbarText: "",
    };
  },
  mounted() {
    if(this.viewType == 'add'){
      this.formData.active = 1
    }
    this.getCountryData();
    if (this.id) this.getById(this.id);
  },
  methods: {
    getCountryData() {
      this.countryData = getGeographicData("country");
      console.log(this.countryData, "this.countryData ");
    },
     handleEditLocation(location) {
      console.log(location, "location")
      this.formData = location;
    },
    chooseState(countryCode) {
      this.formData.state = null;
      this.stateData = null;
      this.stateData = getGeographicData("state", countryCode);
    },
    closeDialog() {
      this.$emit("close-dialog");
    },
    async save(){
      const {valid} = await  this.$refs.form.validate();
        if (valid) {
            if(this.viewType == "edit"){
              this.$emit("update-location",this.formData,this.index)
            }else{
             this.$emit("add-location",this.formData)
            }
            this.$emit("close-dialog");
        } else {
            console.log("Form not valid");
        }   
    },
    getRules(name) {
      if (name && name.toLowerCase() == "email") {
        return [
          (value) => !!value || "E-mail is required.",
          (value) => {
            if (/.+@.+\..+/.test(value)) {
              return true;
            }
            return "E-mail must be valid.";
          },
        ];
      }
      return [
        (value) =>
          (value !== null && value !== undefined && value !== "") ||
          `${name} is required.`,
      ];
    },
  },
};
</script>

<style scoped>

.label {
  font-size: 12px;
  font-weight: 600;
  text-align: left;
}
.labelStar {
  color: #cf0707;
  padding-left: 2px;
  font-weight: 700;
}
.card {
  background-color: #eeeeee;
  border-radius: 12px !important;
  padding: 8px;
  overflow: auto !important;
  width: 100% !important;
}
</style>
